var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.imgs),function(img){return _c('Row',{key:img,staticClass:"img-row",attrs:{"type":"flex","justify":"center","align":"middle"}},[_c('Col',{attrs:{"span":"14"}},[_c('img',{staticClass:"img-item",attrs:{"src":img}})])],1)}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b3ae641","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":true}!./src/pages/cleaner/order-list/order-img.vue
// module id = Br4A
// module chunks = 0